import React from "react";
import Select, { components } from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { getGenders } from "../../actions/left-menu-actions/actions";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface Props {
  allGenders: any;
  handleChangeGender: (x: any) => void;
}

export const SelectGender = ({ allGenders, handleChangeGender }: Props) => {
  const dispatch = useDispatch();
  const { genders } = useSelector((state: any) => state.leftMenu);

  //   React.useEffect(() => {
  //     dispatch(getGenders());
  //   }, []);

  const customStyles = {
    //@ts-ignore
    option: (styles: any, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected ? "#00468c" : null,
        color: isSelected ? "white" : "black",
      };
    },
    control: (base: any) => ({
      ...base,
      border: 0,
      borderBottom: "1px solid #ccc",
      borderRadius: 0,
      padding: 0,
      // This line disable the blue border
      boxShadow: "none",
      "&:hover": {
        outine: "none",
      },
    }),
    menuList: (provided: any, state: any) => ({
      ...provided,
      paddingLeft: 0,
      paddingBottom: 0,
    }),
    menu: (base: any) => ({
      ...base,
      marginTop: 0,
      color: "#00468c",
    }),
    valueContainer: (base: any) => ({
      ...base,
      paddingLeft: 0,
      fontSize: 18,
    }),
    indicatorSeparator: (base: any) => ({
      ...base,
      display: "none",
    }),
    colors: (base: any) => ({
      ...base,
      primary: "#00468c",
      primary25: "#00468c",
    }),
  };

  const DropdownIndicator = (props: any) => {
    return (
      <components.DropdownIndicator {...props}>
        <FontAwesomeIcon icon={faCaretDown} />
      </components.DropdownIndicator>
    );
  };

  return (
    <div className="field field_article mb-0">
      <Select
        options={allGenders}
        styles={customStyles}
        //@ts-ignore
        onChange={(e: any) => handleChangeGender(e)}
        placeholder={
          <div className="react-select-placeholder-input">Gender </div>
        }
        components={{ DropdownIndicator }}
      />
    </div>
  );
};
